import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const useStyles = buildUseStyles('TooltipInfoList', ((theme) => ({
  root: {
    padding: theme.spacing(0),
    margin: theme.spacing(0),
  },
  listItem: {
    listStyleType: 'none',
    color: theme.palette.common.white,
  },
})));

const TooltipInfoList = ({
  items,
}) => {
  const classes = useStyles();

  return (
    <ul className={classes.root}>
      {items.map((v) => {
        return (
          <li className={classes.listItem} key={v}>
            <Text
              variant={'fineprint'}
              color={'white'}
              weight={'medium'}
              key={v}
              value={v}
            />
          </li>
        );
      })}
    </ul>
  );
};

TooltipInfoList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default TooltipInfoList;
